import React from "react";
import siteConfig from "../config/siteConfig";
import "../css/privacy.scss";

const privacySections = [
  {
    title: "Information we collect",
    body: [
      "We collect information you provide when you place an order, create a checkout, contact us, join our mailing list, or otherwise interact with the site. This may include your name, contact details, billing and shipping addresses, order history, and the content of your messages.",
      "We also receive limited technical information such as device type, browser, IP address, pages viewed, referring links, and approximate location. Payment card details are processed by our payment provider and are not stored in full by us.",
    ],
  },
  {
    title: "How we use information",
    body: [
      "We use personal information to process and deliver orders, provide customer care, prevent fraud, maintain and improve the site, comply with legal obligations, and send marketing messages when you have asked to receive them.",
      "Where applicable, our legal bases include performing our contract with you, meeting legal requirements, protecting our legitimate business interests, and your consent.",
    ],
  },
  {
    title: "Cookies and analytics",
    body: [
      "Cookies keep the cart working, remember preferences, help secure checkout, and show us how the site is used. Some are essential; optional analytics or advertising cookies are used only where permitted. Browser settings can block cookies, though parts of checkout may no longer function correctly.",
    ],
  },
  {
    title: "When information is shared",
    body: [
      "We share only what is necessary with providers that support payments, hosting, analytics, email, fraud prevention, warehousing, and delivery. They may use the information only to perform services for us and must protect it appropriately.",
      "We may also disclose information when required by law, to protect customers or our business, or as part of a business reorganization. We do not sell personal information for money.",
    ],
  },
  {
    title: "Retention and security",
    body: [
      "We retain information only as long as needed for the purposes described here, including tax, accounting, dispute, and warranty requirements. We use reasonable administrative and technical safeguards, but no online service can guarantee absolute security.",
    ],
  },
  {
    title: "Your choices and rights",
    body: [
      "Depending on where you live, you may ask to access, correct, delete, restrict, or receive a copy of your personal information, or object to certain uses. You can unsubscribe from marketing at any time using the link in an email. We may need to verify your identity before completing a request.",
    ],
  },
  {
    title: "Children and international visitors",
    body: [
      "This site is not directed to children under 13, and we do not knowingly collect their personal information. If information is processed outside your country, we use appropriate safeguards as required by applicable law.",
    ],
  },
  {
    title: "Updates to this policy",
    body: [
      "We may revise this policy as our services or legal obligations change. The updated date at the top of this page shows when the latest version took effect. Material changes will be communicated where required.",
    ],
  },
];

function Privacy() {
  return (
    <main className="privacy-page">
      <header className="privacy-page__header">
        <p className="privacy-page__eyebrow">Legal</p>
        <h1>Privacy policy</h1>
        <p>Last updated August 15, 2026</p>
      </header>

      <div className="privacy-page__layout">
        <aside className="privacy-page__summary">
          <p>
            This policy explains how {siteConfig.brandName} collects, uses, and
            protects personal information when you visit our site or shop with us.
          </p>
          <a href={`mailto:${siteConfig.contact.email}`}>Ask a privacy question</a>
        </aside>

        <div className="privacy-page__content">
          {privacySections.map((section, index) => (
            <section key={section.title} aria-labelledby={`privacy-section-${index}`}>
              <span>{String(index + 1).padStart(2, "0")}</span>
              <div>
                <h2 id={`privacy-section-${index}`}>{section.title}</h2>
                {section.body.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
              </div>
            </section>
          ))}

          <section aria-labelledby="privacy-contact">
            <span>09</span>
            <div>
              <h2 id="privacy-contact">Contact us</h2>
              <p>
                Questions or privacy requests can be sent to{" "}
                <a href={`mailto:${siteConfig.contact.email}`}>
                  {siteConfig.contact.email}
                </a>
                . If you contact us about a right provided by law, please include
                your country or state of residence and enough detail for us to
                understand the request.
              </p>
            </div>
          </section>
        </div>
      </div>
    </main>
  );
}

export default Privacy;
